import { render, staticRenderFns } from "./Item56Servatur.vue?vue&type=template&id=3cff8fd5&"
import script from "./Item56Servatur.vue?vue&type=script&lang=js&"
export * from "./Item56Servatur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports